import { Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Script } from '../models/script.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicScriptLoaderService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  loadScripts(renderer: Renderer2, scripts: Script[]) {
    scripts.forEach((script) => {
      const scriptElm: HTMLScriptElement = renderer.createElement('script');
      scriptElm.src = script.src;
      scriptElm.async = !!script.async;
      scriptElm.defer = !!script.defer;
      scriptElm.type = 'text/javascript';

      this.document.getElementsByTagName('head')[0].appendChild(scriptElm);
    });
  }
}
